<template>
  <div class="printer-config-page">
    <div class="back-header">
      <div class="back-btn" @click="$router.back()">←</div>
      <h1>{{ $t('printerConfig.yilianyun.title') }}</h1>
      <div style="flex: 1;"></div>
    </div>

    <div class="page-content">
      <div class="config-section">
        <div class="form-item">
          <label>{{ $t('printerConfig.yilianyun.machineCode') }}</label>
          <input type="text" v-model="form.machineCode" :placeholder="$t('printerConfig.yilianyun.machineCodeHint')" />
        </div>

        <div class="form-item">
          <label>{{ $t('printerConfig.yilianyun.msign') }}</label>
          <input type="text" v-model="form.msign" :placeholder="$t('printerConfig.yilianyun.msignHint')" />
        </div>

        <div class="form-item">
          <label>{{ $t('printerConfig.yilianyun.receiptTitle') }}</label>
          <input type="text" v-model="form.receiptTitle" :placeholder="$t('printerConfig.yilianyun.receiptTitleHint')" />
        </div>

        <div class="toggle-row">
          <span class="toggle-label">{{ $t('printerConfig.yilianyun.autoPrint') }}</span>
          <label class="switch">
            <input type="checkbox" v-model="form.enabled" />
            <span class="slider"></span>
          </label>
        </div>
        <p class="toggle-hint">{{ $t('printerConfig.yilianyun.autoPrintHint') }}</p>

        <div class="form-item">
          <label>{{ $t('printerConfig.yilianyun.printCopies') }}</label>
          <input type="number" v-model.number="form.printCopies" placeholder="1" min="1" max="5" />
        </div>

        <div class="help-box">
          <p>{{ $t('printerConfig.yilianyun.helpTitle') }}</p>
          <ol>
            <li>{{ $t('printerConfig.yilianyun.help1') }}</li>
            <li>{{ $t('printerConfig.yilianyun.help2') }}</li>
            <li>{{ $t('printerConfig.yilianyun.help3') }}</li>
          </ol>
        </div>

        <button class="btn-save" @click="onSubmit" :disabled="submitting">
          {{ submitting ? $t('common.loading') : $t('printerConfig.save') }}
        </button>

        <button class="btn-test" @click="testPrint" :disabled="testing">
          {{ testing ? $t('printerConfig.yilianyun.testing') : '🖨️ ' + $t('printerConfig.yilianyun.testPrint') }}
        </button>
      </div>
    </div>

    <div v-if="showToast" class="toast">{{ toastMessage }}</div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'PrinterConfig',
  data() {
    return {
      form: {
        machineCode: '',
        msign: '',
        enabled: true,
        printCopies: 1,
        receiptTitle: '📦 批发订单'
      },
      submitting: false,
      testing: false,
      showToast: false,
      toastMessage: ''
    };
  },
  created() {
    this.loadConfig();
  },
  methods: {
    async loadConfig() {
      try {
        const res = await api.get('/wholesaler/printer-config');
        if (res && res.id != null) {
          this.form.machineCode = res.machineCode || '';
          this.form.msign = res.msign || '';
          this.form.enabled = res.enabled !== undefined ? res.enabled : true;
          this.form.printCopies = res.printCopies || 1;
          this.form.receiptTitle = res.receiptTitle || '📦 批发订单';
        }
      } catch (e) {
        console.error('加载配置失败', e);
      }
    },
    async onSubmit() {
      if (!this.form.machineCode || !this.form.msign) {
        this.showToastMsg(this.$t('common.required'));
        return;
      }
      this.submitting = true;
      try {
        await api.post('/wholesaler/printer-config', this.form);
        this.showToastMsg('✅ ' + this.$t('common.operationSuccess'));
      } catch (e) {
        this.showToastMsg(this.$t('common.operationFailed') + ': ' + (e.message || ''));
      } finally {
        this.submitting = false;
      }
    },
    async testPrint() {
      this.testing = true;
      try {
        const res = await api.get('/wholesaler/printer/test');
        if (res && res.success) {
          this.showToastMsg('✅ ' + this.$t('printerConfig.yilianyun.testSuccess'));
        } else {
          this.showToastMsg(this.$t('common.operationFailed') + ': ' + (res.message || ''));
        }
      } catch (e) {
        this.showToastMsg(this.$t('common.operationFailed') + ': ' + (e.message || ''));
      } finally {
        this.testing = false;
      }
    },
    showToastMsg(msg) {
      this.toastMessage = msg;
      this.showToast = true;
      setTimeout(() => { this.showToast = false; }, 2500);
    }
  }
};
</script>

<style scoped>
.printer-config-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding-bottom: 80px;
}
.back-header {
  display: flex;
  align-items: center;
  padding: calc(12px + env(safe-area-inset-top, 0px)) 16px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  position: sticky;
  top: 0;
  z-index: 100;
}
.back-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
}
.back-header h1 {
  flex: 1;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin: 0 12px;
}
.page-content { padding: 12px; }
.config-section {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.form-item { margin-bottom: 16px; }
.form-item:last-child { margin-bottom: 0; }
.form-item label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #555;
}
.form-item input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
}
.form-item input:focus { border-color: #667eea; outline: none; }
.toggle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}
.toggle-label { font-size: 14px; color: #333; }
.toggle-hint { font-size: 12px; color: #999; margin: 4px 0 0 0; }
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 28px;
}
.switch input { opacity: 0; width: 0; height: 0; }
.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 28px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}
input:checked + .slider { background-color: #667eea; }
input:checked + .slider:before { transform: translateX(22px); }
.help-box {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  margin-top: 16px;
}
.help-box p {
  margin: 0 0 8px 0;
  font-size: 13px;
  font-weight: 600;
  color: #333;
}
.help-box ol {
  margin: 0;
  padding-left: 20px;
  font-size: 12px;
  color: #666;
  line-height: 1.8;
}
.btn-save, .btn-test {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 12px;
}
.btn-save {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}
.btn-save:active { opacity: 0.9; transform: scale(0.98); }
.btn-test {
  background: #fff;
  color: #065f46;
  border: 2px solid #34d399;
}
.btn-test:disabled, .btn-save:disabled { opacity: 0.6; cursor: not-allowed; }
.toast {
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0,0,0,0.8);
  color: #fff;
  padding: 12px 20px;
  border-radius: 20px;
  font-size: 13px;
  z-index: 2000;
}
</style>